// extracted by css-extract-rspack-plugin
export default {"GitHubAvatar":"use-assignees-editor-module__GitHubAvatar__Q6KfJD6"};